import { SVGProps, SVGAttributes } from 'react';

const KeyOutlined = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
  const { width, height, stroke } = props;

  return (
    <svg
      width={width || '35'}
      height={height || '35'}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5129_15544"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width || '35'}
        height={height || '35'}
      >
        <rect width={width || '35'} height={height || '35'} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5129_15544)">
        <path
          d="M10.2084 20.4167C9.40629 20.4167 8.7199 20.1308 8.14921 19.5592C7.57754 18.9885 7.29171 18.3021 7.29171 17.5C7.29171 16.6979 7.57754 16.011 8.14921 15.4394C8.7199 14.8687 9.40629 14.5833 10.2084 14.5833C11.0105 14.5833 11.6968 14.8687 12.2675 15.4394C12.8392 16.011 13.125 16.6979 13.125 17.5C13.125 18.3021 12.8392 18.9885 12.2675 19.5592C11.6968 20.1308 11.0105 20.4167 10.2084 20.4167ZM10.2084 26.25C7.77782 26.25 5.71185 25.3993 4.01046 23.6979C2.30907 21.9965 1.45837 19.9306 1.45837 17.5C1.45837 15.0694 2.30907 13.0035 4.01046 11.3021C5.71185 9.60069 7.77782 8.75 10.2084 8.75C11.8368 8.75 13.3137 9.15104 14.6388 9.95312C15.963 10.7552 17.0139 11.8125 17.7917 13.125H30.625L35 17.5L28.4375 24.0625L25.5209 21.875L22.6042 24.0625L19.5052 21.875H17.7917C17.0139 23.1875 15.963 24.2448 14.6388 25.0469C13.3137 25.849 11.8368 26.25 10.2084 26.25ZM10.2084 23.3333C11.5695 23.3333 12.7668 22.9201 13.8002 22.0937C14.8327 21.2674 15.5191 20.2222 15.8594 18.9583H20.4167L22.5313 20.4531L25.5209 18.2292L28.1094 20.2344L30.8438 17.5L29.3855 16.0417H15.8594C15.5191 14.7778 14.8327 13.7326 13.8002 12.9063C12.7668 12.0799 11.5695 11.6667 10.2084 11.6667C8.60421 11.6667 7.23094 12.2378 6.08858 13.3802C4.94622 14.5226 4.37504 15.8958 4.37504 17.5C4.37504 19.1042 4.94622 20.4774 6.08858 21.6198C7.23094 22.7622 8.60421 23.3333 10.2084 23.3333Z"
          fill={stroke || '#1976D2'}
        />
      </g>
    </svg>
  );
};

export default KeyOutlined;
